import { Text } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const Installments = ({ isBlackWeekend, isBranded, installments }) => {
  const hasInstallments = parseInt(installments?.amount || 0) > 1

  if (!hasInstallments) {
    return null
  }

  return (
    <S.Installments isBlackWeekend={isBlackWeekend}>
      {isBranded
        ? (
            <Text size="kilo" noMargin data-testid="branded-installments">
              <Text as="strong" bold size="kilo" noMargin>
                {installments.amount}x{' '}
              </Text>
              s/ juros no cartão{' '}
              <Text as="strong" bold size="kilo" noMargin>
                Celebre!
              </Text>
            </Text>
          )
        : (
            <Text size="kilo" bold noMargin>
              {installments.amount}x de R$ {installments.value} sem juros
            </Text>
          )}
    </S.Installments>
  )
}

export default Installments
